"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoftPaymentError = void 0;
class SoftPaymentError extends Error {
    metadata;
    constructor(error, metadata) {
        super(typeof error === "string" ? error : error.message);
        this.metadata = metadata;
    }
}
exports.SoftPaymentError = SoftPaymentError;
//# sourceMappingURL=SoftPaymentError.js.map